import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';

@Component({
    selector: 'cv-cxone-dashboard-name-cell-renderer',
    templateUrl: './cxone-dashboard-name-cell-renderer.component.html',
    styleUrls: ['./cxone-dashboard-name-cell-renderer.component.scss']
})
export class CxoneDashboardNameCellRendererComponent implements AgRendererComponent {

    params: ICellRendererParams;
    value: string;
    isAbandoned: boolean;
    hasReadAccess: boolean;
    searchFilter: string;
    minSearchLength = 2;

    agInit(params: ICellRendererParams) {
        this.params = params;
        this.value = params.valueFormatted;
        this.isAbandoned = this.params.context?.contextUtil?.isDashboardAbandoned(this.params.data.DashboardKey);
        this.hasReadAccess = this.params.context?.contextUtil?.hasReadAccess(this.params.data);
        this.searchFilter = this.params.context?.contextUtil?.getFilterText();
        this.params.eGridCell.addEventListener("keypress", (event) => this.onDashboardClick(event));
    }

    refresh(params: ICellRendererParams) {
        this.params = params;
        this.value = params.valueFormatted;
        this.isAbandoned = this.params.context?.contextUtil?.isDashboardAbandoned(this.params.data.DashboardKey);
        this.hasReadAccess = this.params.context?.contextUtil?.hasReadAccess(this.params.data);
        this.searchFilter = this.params.context?.contextUtil?.getFilterText();
        return true;
    }

    onDashboardClick(event: Event) {
        event.preventDefault();
        if (typeof this.params['dashboardClicked'] === 'function' && this.hasReadAccess)
            this.params['dashboardClicked'](this.params.node.id);
    }
}
